module.exports = __webpack_public_path__ + "static/img/button-2.d4ba34db.jpeg";